import { render, staticRenderFns } from "./AuthResetPass.vue?vue&type=template&id=01d564fa&scoped=true&"
import script from "./AuthResetPass.vue?vue&type=script&lang=js&"
export * from "./AuthResetPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d564fa",
  null
  
)

export default component.exports